import "./Flex_module.css";
const Flex_module_rslib_entry_ = {
    flex: "flex-iIKufS"
};
export { Flex_module_rslib_entry_ as default };

//# sourceMappingURL=Flex.module.js.map